import React from 'react';
import EntityHistoryCard from './EntityHistoryCard';
import { KoobSkeleton } from '@koob/ui';

export default function EntityHistoryList({
  items = [],
  isLoading = false,
  emptyMessage = 'No history available',
  fieldLabels = {},
  actionLabels = {},
  renderCard,
  loadingComponent,
}) {
  if (isLoading) {
    if (loadingComponent) {
      return loadingComponent;
    }
    return <KoobSkeleton shape="rows" />;
  }

  if (!items || items.length === 0) {
    return (
      <div className="flex justify-center items-center py-12">
        <p className="text-gray-500 text-lg italic">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((history, index) => {
        if (renderCard) {
          return renderCard(history, index);
        }

        return (
          <EntityHistoryCard
            key={history.id || index}
            history={history}
            fieldLabels={fieldLabels}
            actionLabelsOverride={actionLabels}
          />
        );
      })}
    </div>
  );
}
